import { Component, OnInit } from '@angular/core';
import { OrderService } from 'src/app/services/order.service';
import { ActivatedRoute } from '@angular/router';
import { Order } from 'src/app/models/order';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss']
})
export class OrderComponent implements OnInit {
  private order_id: number;
  public order: Order;
  public loadingOrder: boolean = true;
  constructor(private orderService: OrderService, private route: ActivatedRoute) { 
    this.route.params.subscribe(params => {
      this.order_id = +params['id'];
   });
  }

  ngOnInit() {
    this.orderService.getOrder(this.order_id).subscribe(res=>{
      this.order = res;
      this.loadingOrder = false;
    })
  }

}
